/** Alinhado a `server/src/lib/trash-retention.ts` (dias na lixeira antes do purge). */
export const DIAS_RETENCAO_LIXEIRA = 30;
